import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class CalculatorLoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private contentSubject = new BehaviorSubject<string>('');
  public content$ = this.contentSubject.asObservable();

  private contentArray: string[] = [
    "Calculating premium...",
    "Evaluating risk factors...",
    "Preparing quotation details...",
    "Finalizing calculations..."
  ];
  private currentIndex = 0;
  private intervalSubscription: Subscription | null = null;

  constructor(private http: HttpClient, private loaderService : LoaderService) {
   
  }

  // Show the loader and start rotating content
  show(): void {
    if (!this.intervalSubscription) {
      this.loadingSubject.next(true);
      this.loaderService.hide();
      this.startContentRotation(); // Start the rotation of content
    }
  }

  // Stop the loader and the rotation of content
  hide(): void {
    this.loadingSubject.next(false);
    this.stopContentRotation(); // Manually stop content rotation
  }

  // Load content array from a JSON file or hardcoded data
  loadContent(filePath: string): void {
    this.http.get<string[]>(filePath).subscribe((content) => {
      this.contentArray = content;
      this.currentIndex = 0; // Start from the beginning of the array
    });
  }

  // Start rotating content every second
  private startContentRotation(): void {
    if (this.contentArray.length === 0) {
      console.warn('No content available to display.');
      return;
    }

    // Use interval to switch content every second
    this.intervalSubscription = interval(1000).subscribe(() => {
      const selectedContent = this.contentArray[this.currentIndex];
      this.contentSubject.next(selectedContent); // Display next content

      // Move to the next content, loop back to start when necessary
      this.currentIndex = (this.currentIndex + 1) % this.contentArray.length;
    });
  }

  // Stop the rotation of content
  private stopContentRotation(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe(); // Stop the interval
      this.intervalSubscription = null; // Clear the subscription
    }
  }
}
